import { useTranslation } from 'react-i18next';
import DashedCard from '../UI/DashedCard';
import RoleSelector from './RoleSelector';

import classes from './PanelUserBody.module.scss';
import UsersTable from './UsersTable';

export default function PanelUserBody() {
  const { t } = useTranslation('panel');

  return (
    <>
      <DashedCard confirmText="Add New User +" discardText="Discard">
        <form onSubmit={(e) => e.preventDefault()} className={classes.inputs}>
          <input
            placeholder={t('Raw')}
            className={`${classes.input} ${classes.raw}`}
          />
          <input
            placeholder={t('Username')}
            className={`${classes.input} ${classes.username}`}
          />
          <input
            placeholder={t('Company')}
            className={`${classes.input} ${classes.company}`}
          />
          <input
            placeholder={t('Address')}
            className={`${classes.input} ${classes.address}`}
          />
          <RoleSelector />
        </form>
      </DashedCard>
      <UsersTable />
    </>
  );
}
